<div class="auth-callback-root">
  <div class="auth-card">
    <div class="spinner" aria-hidden="true"></div>
    <h3>Processing sign‑in…</h3>
    <p class="muted">You will be redirected shortly.</p>
    <button type="button" class="recover-link" (click)="onRecover()">
      Recover
    </button>
  </div>
</div>
